/* routes.js */
export const homePath = "/";
export const imprintPath = "/imprint/";
export const privacyPath = "/privacy/";